var $ = require("jquery");
var Freezer = require("freezer-js");

let moduleName = $("#app").attr("data-module-name") || "flex";
let storage = (namespace, data) => {
    //if (data) {
    //    return localStorage.setItem(namespace, JSON.stringify(data));
    //}

    //let store = localStorage.getItem(namespace);
    return (store && JSON.parse(store)) || false;
};


// Set template for state so properties are always there (reduce null checks)
const initialStoreData = {
    appContext: {},
    busy: {},
    flags: {},
    forms: {}
}; 

// Returns the freezer instance with the state.
let store = new Freezer(initialStoreData);
store.on('beforeAll', function( eventName, params, param2, param3 ){   
    if(eventName === "update") return;
    if(!this._events[ eventName ]) console.warn(`A reaction does not yet exist to handle trigger: "${eventName}"`);
    else console.log( `REACTION TRIGGERING [${eventName}]:`, params);
});
store.on('afterAll', function( eventName, params ){   
    
});
module.exports = store;